'use client';

import { usePathname } from 'next/navigation';

import { localeFromPath } from '../_lib/marketing-routes';
import { LpHeader } from './lp-header';
import { SiteHeader } from './site-header';

/**
 * Dünner Client-Switch für den Marketing-Header: auf Ad-Landing-Pages (`/lp/*`,
 * inkl. `/en/lp/*` + `/fr/lp/*`) den reduzierten `LpHeader` (Logo + 1 CTA, kein
 * `useUser`), sonst den vollen `SiteHeader`. `SiteHeader` bleibt unangetastet –
 * sein `useUser()`-Auth-Roundtrip läuft auf LP nie, weil er dort nicht gemountet
 * wird. Die Locale des LpHeaders kommt aus dem Pfad (DE/EN/FR-LP).
 *
 * Konvention: Künftige Ad-LPs MÜSSEN `/lp/` im Pfad haben, sonst greift der
 * Minimal-Header nicht.
 */
export function MarketingHeader() {
  const pathname = usePathname() ?? '';

  // Messe-Seite `/messe` (Spec 2026-10-25-messe-seite §4.3): Kopf wie die
  // Gewinnerseiten, ohne „Kostenlos starten“.
  if (pathname === '/messe') {
    return <LpHeader locale="de" ohneAktion />;
  }

  // matcht `/lp/`, `/en/lp/`, `/fr/lp/` – nicht nur die DE-Root-LPs.
  if (/\/lp\//.test(pathname)) {
    // Messe-Aktionsseiten (`/lp/aktion/…`): nur das Formular, kein zweites Ziel
    // im Kopf (Auftraggeber 12.10.2026).
    return (
      <LpHeader
        locale={localeFromPath(pathname)}
        ohneAktion={/\/lp\/aktion\//.test(pathname)}
      />
    );
  }

  return <SiteHeader />;
}
